import React from 'react';

/** @param {string} title */
export function parseGameTitle(title) {
    const trimmed = title.trim();
    const spaceIndex = trimmed.indexOf(' ');

    if (spaceIndex === -1) {
        return { mode: 'plain', text: trimmed };
    }

    return {
        mode: 'mark',
        lead: trimmed.slice(0, spaceIndex),
        pop: trimmed.slice(spaceIndex + 1).trim(),
        full: trimmed,
    };
}

/**
 * Wordmark for multi-word titles (e.g. "Lead Pop"). Falls back to plain text.
 * @param {{ title: string }} props
 */
export function GameTitleMark({ title }) {
    const parsed = parseGameTitle(title);

    if (parsed.mode === 'plain') {
        return <h1 className="lp-game__title lp-game__title--plain">{parsed.text}</h1>;
    }

    const { lead, pop, full } = parsed;

    return (
        <h1 className="lp-game__title-mark" title={full}>
            <span className="lp-game__title-mark-lead">{lead}</span>
            <span className="lp-game__title-mark-pop" aria-hidden={!pop}>
                {pop}
                <span className="lp-game__title-mark-bubble" aria-hidden="true" />
            </span>
        </h1>
    );
}
